import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { useSnackbar } from 'notistack';

export default function SnackbarCloseButton({
  snackbarId,
}: {
  snackbarId: string | number;
}) {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton
      size="small"
      aria-label="Close notification"
      color="inherit"
      onClick={() => closeSnackbar(snackbarId)}
      sx={{ ml: 0.5, p: 0.25 }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
}
